/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { productListStyles } from "@monsma/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import { screen } from "@monsma/XDL/Helpers";
import IconReorder from "@monsma/XDL/Icons/IconReorder";
import { css } from "styled-components";

productListStyles.container = {
    gap: 0,
    css: css`
        background: ${getColor("common.background")};
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid ${getColor("common.border")};
        margin-top: 25px;
    `,
};

productListStyles.lineGridItem = {
    width: 12,
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
        padding: 20px;
        justify-content: space-between;

        &:last-child {
            border-bottom: 0;
        }

        ${screen("lte", "md")} {
            display: flex;
            flex-direction: column;
            position: relative;
        }

        @media print {
            display: block !important;
            page-break-inside: avoid;
        }
    `,
};

productListStyles.sortOrderWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 24px;
        margin-right: 20px;
        position: relative;

        ${screen("gt", "md")} {
            height: 100%;
            justify-content: center;
        }

        ${screen("lte", "md")} {
            flex-direction: row;
            position: absolute;
            top: 12px;
            left: 20px;
            width: 90px;
        }

        @media print {
            display: none;
        }
    `,
};

productListStyles.dragHandleIcon = {
    src: IconReorder,
    size: 24,
    css: css`
        cursor: move;
    `,
};

productListStyles.sortOrderTextField = {
    labelPosition: "top",
    labelProps: {
        size: 9,
        transform: "uppercase",
        css: css`
            min-height: auto;
            text-align: center;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                /* ISC-11023 deal with this. */
                /* stylelint-disable-next-line */
                -webkit-appearance: none;
                margin: 0;
            }
        `,
        formField: css`
            ${screen("gt", "md")} {
                margin-bottom: 10px;
                position: absolute;
                top: 0;
                left: 0;
                width: 60px;
            }

            ${screen("lte", "md")} {
                margin-left: 10px;
            }
        `,
        inputSelect: css`
            text-align: center;

            /* ISC-11023 deal with this. */
            /* stylelint-disable-next-line */
            -moz-appearance: textfield;
            height: 30px;
        `,
    },
};

productListStyles.editNotesModal = { sizeVariant: "medium" };
